module.exports = __webpack_public_path__ + "img/edit-fill-disable.a79f9516.png";